import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const I18nContext = createContext(null);

export const I18nProvider = ({ children }) => {
  const [lang, setLangState] = useState(localStorage.getItem("lang") || "cs");
  const [strings, setStrings] = useState(null);
  const [languages, setLanguages] = useState([{ code: "cs", name: "Čeština" }]);

  useEffect(() => {
    api.get("/i18n/languages").then(({ data }) => setLanguages(data)).catch(() => {});
  }, []);

  useEffect(() => {
    api.get(`/i18n/${lang}`).then(({ data }) => setStrings(data)).catch(() => setStrings({}));
  }, [lang]);

  const setLang = (l) => {
    localStorage.setItem("lang", l);
    setLangState(l);
  };

  const t = (k) => (strings && strings[k]) || k;

  if (strings === null) return <div className="min-h-screen bg-[#0B0F17]" />;

  return (
    <I18nContext.Provider value={{ t, lang, setLang, languages }}>
      {children}
    </I18nContext.Provider>
  );
};

export const useI18n = () => useContext(I18nContext);
